import {FormControl, InputLabel, MenuItem, Select, TextField, Typography} from "@mui/material";
import React from "react";
import {UserInputSettings} from "./components/user-input-settings";


export const ChoiceSettings = ({node, setNode, project, onUpdate, onChangeData, nodes}) => {


  return (
    <>
      <Typography fontWeight={700} fontSize={13}>Source</Typography>
      <TextField
        value={node?.data?.options || ""}
        size={"small"}
        label={"Options"}
        placeholder={"${global.[variable_name]}"}
        helperText={"Please enter a variable name that includes options."}
        onChange={(e) => onChangeData('options', e.target.value || "")}
        onBlur={() => onUpdate(node)}
      />
      <Typography fontWeight={700} fontSize={13}>Parameter</Typography>
      <FormControl size={"small"} fullWidth>
        <InputLabel id="demo-entity-select-label">Parameter Entity</InputLabel>
        <Select
          labelId="demo-entity-select-label"
          id="demo-entity-select"
          value={node?.data?.parameter?.entity_type}
          label="Parameter Entity"
          onChange={(e) => onChangeData('parameter', {
            entity_type: e.target.value,
            name: node?.data?.parameter?.name || ""
          })}
          onBlur={() => onUpdate(node)}
        >
          <MenuItem value={""}><em>None</em></MenuItem>
          {
            project?.entities?.map(entity => <MenuItem key={entity?.id}
                                                       value={entity?.name}>{entity?.name}</MenuItem>)
          }
        </Select>
      </FormControl>
      <TextField
        value={node?.data?.parameter?.name || ""}
        size={"small"}
        label={"Parameter name"}
        placeholder={"Enter the name of the parameter"}
        helperText={"With this name you will be able to further access the variable."}
        onChange={(e) => onChangeData('parameter', {
          entity_type: node?.data?.parameter?.entity_type || "",
          name: e.target.value || ""
        })}
        onBlur={() => onUpdate(node)}
      />
      <UserInputSettings node={node} onUpdate={onUpdate} onChangeData={onChangeData} />

    </>
  )
}